export default __webpack_public_path__ + "static/media/dots-gray-top-right.417861ce.svg";